import _ from 'lodash';

export const selectItemForm = state => _.get(state, ['itemForm'], {});

export const selectItemFormData = state => _.get(selectItemForm(state), ['data'], {});
